module.exports = __webpack_public_path__ + "static/media/docx.e7113b63.svg";